export const LAZY_LOAD_TOP_OFFSET = 800;
export const CYCLE_SPEED = 1500;
export const FIRST_IMAGE_CYCLE_SPEED = CYCLE_SPEED * 0.66;
export const FAVORITE_SUGGESTION_DURATION = 9000;
